import { StyledContainer } from "../table/styled-components/StyledContainer";
import { User } from "../../UserManagerApi";
import { TableCell, Box, CircularProgress, Grid } from "@mui/material";
import { StyledTableRow } from "../table/styled-components/StyledTableRow";
import { getMenuItems } from "../table/user-table-actions/UserTableActions";
import { useMsal } from "@azure/msal-react";
import UserInitials from "../user-initials/UserInitials";
import { COLOR, ICON_TYPE } from "../../utils/enums/globalEnums";
import { getIcon } from "../../utils/iconHelper";
import { getEnumTypeText } from "../../utils/helper-functions/HelperFunctions";
import StyledMenu from "../menu/StyledMenu";
import styles from "../tabs/TabStyles.module.scss";

type Props = {
  users: User[];
  isLoading: boolean;
};

const MobileUserTab = ({ users, isLoading }: Props) => {
  const { accounts } = useMsal();

  return (
    <div>
      {isLoading ? (
        <StyledTableRow>
          <TableCell colSpan={5}>
            <Box justifyContent={"center"} display={"flex"} mt={5} mb={5}>
              <CircularProgress size={80} />
            </Box>
          </TableCell>
        </StyledTableRow>
      ) : users?.length === 0 ? (
        <StyledTableRow>
          <TableCell colSpan={5}>
            <Box justifyContent={"center"} display={"flex"} mt={5} mb={5}>
              Nincsenek elérhető adatok
            </Box>
          </TableCell>
        </StyledTableRow>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            marginBottom: "20px",
          }}
        >
          {users.map((user, index) => {
            const menuItems = getMenuItems(user, accounts[0]?.localAccountId);
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  gap: "5px",
                  flexDirection: "column",
                  padding: "10px",
                  border: "1px solid transparent",
                  borderRadius: "20px",
                  backgroundColor:
                    accounts?.length > 0 &&
                    user?.objectId === accounts[0]?.localAccountId
                      ? "rgba(80, 143, 217, 0.5)"
                      : "white",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <UserInitials name={`${user.lastName} ${user.firstName}`} />

                  <div className={styles["username-cell"]}>
                    {`${user.lastName} ${user.firstName}`}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <span>E-mail:</span>
                  <span>{user.email}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <span>Jogosultság:</span>
                  <span>{getEnumTypeText(user.role)}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  <span>Státusz:</span>
                  <span>{getEnumTypeText(user.invitationStatus)}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <StyledMenu
                    child={getIcon(ICON_TYPE.OTHER)}
                    text=""
                    color={COLOR.WHITE}
                    menuItems={menuItems}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MobileUserTab;
